// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';
import * as React from 'react';

import { LocationDO } from '../../requests';

interface Props {
  formValues: {
    data: Partial<LocationDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showMap: () => void;
}

/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
function Form(props: Props): JSX.Element {
  const { data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Code</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.code"
            name="data.code"
            value={_.defaultTo(data.code, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Code"
            required
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.name"
            name="data.name"
            value={_.defaultTo(data.name, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Name"
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Address</b> &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
          </label>
          <input
            type="text"
            id="data.address"
            name="data.address"
            value={_.defaultTo(data.address, '')}
            onChange={props.onChange}
            className="input-new"
            style={{ width: '80%' }}
            placeholder="Address"
          />
        </div>
        <div className="col-2">
          <label className="label">
            <b>Latitude:</b>
          </label>
          <input
            type="number"
            id="data.latitude"
            name="data.latitude"
            value={data?.latitude || ''}
            onChange={props.onChange}
            data-ctype="number"
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Latitude"
            required
            step="any"
          />
        </div>
        <div className="col-2">
          <label className="label">
            <b>Longitude:</b>
          </label>
          <input
            type="number"
            id="data.longitude"
            name="data.longitude"
            value={data?.longitude || ''}
            onChange={props.onChange}
            data-ctype="number"
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Longitude"
            required
            step="any"
          />
        </div>
        <div className="col-2">
          <label className="label">&nbsp;</label>
          <button
            type="button"
            onClick={props.showMap}
            className="btn btn-secondary"
            style={{ margin: '0px 0 0 5px', padding: '0 22px', height: '31px' }}
          >
            Map
          </button>
        </div>
      </div>
    </fieldset>
  );
}

export default Form;
